import dayjs from "dayjs";

// Plain calendar comparisons (not the holiday-aware "last working day" used
// by the Collections entry screens' own Yesterday quick-filter) - a KPI
// card comparing "today vs yesterday" means the actual previous calendar
// day, same convention as every off-the-shelf admin dashboard.
const fmt = (d) => d.format("YYYY-MM-DD");

export const dateRanges = () => {
  const today = dayjs();
  const yesterday = today.subtract(1, "day");
  const dayBeforeYesterday = today.subtract(2, "day");
  const monthStart = today.startOf("month");
  const lastMonthStart = today.subtract(1, "month").startOf("month");
  const lastMonthSamePoint = lastMonthStart.add(today.date() - 1, "day");
  const sevenDaysAgo = today.subtract(6, "day");

  return {
    today: fmt(today),
    yesterday: fmt(yesterday),
    dayBeforeYesterday: fmt(dayBeforeYesterday),
    monthStart: fmt(monthStart),
    lastMonthStart: fmt(lastMonthStart),
    lastMonthSamePoint: fmt(lastMonthSamePoint),
    sevenDaysAgo: fmt(sevenDaysAgo),
  };
};

export const money = (n) => {
  const v = Number(n) || 0;
  return `KSh ${v.toLocaleString("en-KE", { maximumFractionDigits: 0 })}`;
};

// Returns null (renders as "-", no arrow) when there's no meaningful prior
// value to compare against, rather than a misleading "+100%"/"-100%" off a
// zero base.
export const percentChange = (current, previous) => {
  const cur = Number(current) || 0;
  const prev = Number(previous) || 0;
  if (!prev) return null;
  return ((cur - prev) / prev) * 100;
};

export const sumBy = (rows, field) => (rows || []).reduce((s, r) => s + (Number(r[field]) || 0), 0);
